import { z } from "zod";
import {
  researchJobStatusSchema,
  researchStageSchema,
} from "../enums.js";
import {
  costUsdSchema,
  isoDateTimeSchema,
  nonEmptyStringSchema,
  uuidSchema,
} from "../primitives.js";

export const researchJobSchema = z.object({
  id: uuidSchema,
  user_id: uuidSchema,
  query: nonEmptyStringSchema,
  region: nonEmptyStringSchema,
  criteria_json: z.record(z.string(), z.unknown()),
  target_count: z.number().int().min(1).max(100),
  status: researchJobStatusSchema,
  current_stage: researchStageSchema,
  candidates_found: z.number().int().nonnegative(),
  candidates_processed: z.number().int().nonnegative(),
  leads_qualified: z.number().int().nonnegative(),
  workflow_instance_id: z.string().nullable(),
  error: z.string().nullable(),
  cost_usd_estimate: costUsdSchema,
  cost_breakdown_json: z.record(z.string(), z.unknown()),
  heartbeat_at: isoDateTimeSchema.nullable(),
  cancel_requested_at: isoDateTimeSchema.nullable(),
  created_at: isoDateTimeSchema,
  started_at: isoDateTimeSchema.nullable(),
  completed_at: isoDateTimeSchema.nullable(),
});

export type ResearchJob = z.infer<typeof researchJobSchema>;

export const createResearchJobResultSchema = z.object({
  research_job_id: uuidSchema,
  status: researchJobStatusSchema,
  workflow_instance_id: z.string().nullable(),
});

export type CreateResearchJobResult = z.infer<typeof createResearchJobResultSchema>;
